import React, { useEffect, useState } from 'react'

import _ from 'underscore'
import {
  Button,
  Container,
  Header,
  Form,
  Icon,
  Input,
  List,
  Loader,
  Segment
} from 'semantic-ui-react'

import fetch from 'isomorphic-fetch'

import { parseDate } from './parsers'
import validate from './validate'
import Env from './Env'

import { useHistory, useLocation } from 'react-router-dom'

const ROOT_URL = Env.ROOT_URL

const getValidationCount = () => {
  const regex = /validationCount=(.*?)(;|$)/
  if (!regex.test(document.cookie)) {
    console.log('validation count 0')
    return 0
  } else {
    console.log('validation count', regex.exec(document.cookie)[1])
    return parseInt(regex.exec(document.cookie)[1])
  }
}

export default function FileSelector(props) {
  const history = useHistory()
  const location = useLocation()

  //hack to clear out selected sedds when the location changes
  useEffect(() => {
    props.setSedds([])
  }, [location])

  const [dateValidationStarted, setDateValidationStarted] = useState(null)
  const { requiredFields, validFields } = props

  const xPath = (selector, doc) => {
    return doc.evaluate(selector, doc, null, XPathResult.ANY_TYPE, null)
  }

  const incrementValidationCount = () => {
    console.log('incrementing validation count')
    document.cookie = 'validationCount=' + (getValidationCount() + 1)
  }

  const runValidation = () => {
    incrementValidationCount()
    setDateValidationStarted(Date.now())
    props.sedds.forEach((sedd, index) => {
      validate(
        sedd.xmlDoc,
        sedd.rawXml,
        requiredFields,
        validFields,
        ({ errors, warnings, validated, message }) => {
          _.extend(sedd, { errors, warnings, validated: !!validated })
          if (_.all(props.sedds, sedd => sedd.validated)) {
            history.push('/report')
          }
          props.forceUpdate()
        }
      )
    })
  }

  const isValidationInProgress = () => {
    const inProgress = dateValidationStarted && !_.all(props.sedds, sedd => sedd.validated)
    return !!inProgress
  }

  const handleFiles = () => {
    const files = document.getElementById('fileInput').files
    const sedds = _.times(files.length, i => {
      return {}
    })
    props.setSedds(sedds)
    if (files.length === 0) return
    for (let i = 0; i < files.length; i++) {
      const reader = new FileReader()
      reader.onload = event => {
        const sedd = sedds[i]
        sedd.rawXml = event.target.result
        const parser = new DOMParser()
        sedd.xmlDoc = parser.parseFromString(sedd.rawXml, 'application/xml')

        const fields = {}
        ;[
          'ClientName',
          'DateFormat',
          'EDDImplementationID',
          'LabDataPackageID',
          'LabName',
          'LabName',
          'LabReportedDate',
          'ProjectName'
        ].forEach(field => {
          const value = xPath(`//Header/${field}`, sedd.xmlDoc).iterateNext()
          fields[field] = value && value.textContent
        })

        sedd.seddInfo = {
          clientName: fields.ClientName,
          eddImplementationId: fields.EDDImplementationID,
          labDataPackageId: fields.LabDataPackageID,
          labName: fields.LabName,
          labReportedDate: parseDate(
            fields.LabReportedDate,
            fields['DateFormat'].replace(/\.sTZD$/, '')
          ),
          projectName: fields.ProjectName
        }
        props.forceUpdate()
      }
      reader.readAsText(files[i])
    }
  }

  return (
    <Container style={{ paddingTop: 50, paddingBottom: 100 }}>
      <Header
        as="h1"
        textAlign="center"
        style={{
          fontSize: '400%',
          paddingBottom: 60,
          fontFamily: 'Open Sans'
        }}
      >
        ChemData SEDD Validator
        <Header.Subheader>Build: 1/28/2022</Header.Subheader>
      </Header>

      <Form size="huge">
        <Form.Select
          placeholder="Select a rule set"
          options={[{ text: 'ChemData', value: 'chemData', key: 'chemData' }]}
        />

        <Form.Field>
          <Button as="label" htmlFor="fileInput">
            Select SEDD XML File
          </Button>

          <Input
            accept=".xml"
            name="fileInput"
            multiple={true}
            id="fileInput"
            style={{ opacity: 0, height: 0, width: 0, position: 'absolute' }}
            type="file"
            onChange={handleFiles}
          />
        </Form.Field>

        {props.sedds &&
          props.sedds.map((sedd, index) => {
            console.log('sedd', sedd['seddInfo'])
            console.log('info', sedd.seddInfo)
            if (!sedd.seddInfo) return <div key={index}>Loading...</div>
            return (
              <List size="small" key={sedd.seddInfo.labDataPackageId}>
                <List.Item>
                  <List.Icon name="file alternate" />
                  <List.Content>
                    <List.Header>
                      {sedd.seddInfo.labName} / {sedd.seddInfo.labDataPackageId}{' '}
                    </List.Header>
                    <List.Description>{sedd.seddInfo.eddImplementationId}</List.Description>
                  </List.Content>
                </List.Item>
              </List>
            )
          })}

        {!isValidationInProgress() ? (
          <div style={{ textAlign: 'center' }}>
            <Button
              disabled={props.sedds.length === 0 || !_.all(props.sedds, sedd => sedd.seddInfo)} //make sure all sedds have been read
              primary
              size="huge"
              onClick={runValidation}
            >
              <Icon name="calculator" /> Validate
            </Button>
          </div>
        ) : (
          <Loader active inline="centered">
            Validating...
          </Loader>
        )}
      </Form>
      {/* <Segment style={{ position: 'absolute', width: '1126px', bottom: '50px' }}> */}
      <Segment style={{ marginTop: 100 }}>
        <h3 style={{ textAlign: 'center', paddingBottom: '20px' }}>TERMS AND CONDITIONS</h3>
        <div style={{ color: 'gray' }}>
          <p>
            Welcome to the ChemData staged electronic data deliverable (SEDD) screener. This is a
            free tool that checks for general compliance with the EPA SEDD v5.2 2A standard, as well
            as additional specifications for our in-house data management system. These include
            required fields, correct data types, and valid values. For more information on the
            ChemData specifications, please{' '}
            <a href="https://www.arcticdataservices.com/tools/sedd-specs">click here</a>. Please
            note that conformance to our specifications does not guarantee conformance to the EPA
            SEDD specifications, or to those of other data management systems. Also please note that
            the ChemData specifications change from time to time. Arctic Data Services, LLC (ADS)
            disclaims responsibility for any direct or indirect damages from the use of this web
            site.
          </p>
          <p>
            ADS is committed to maintaining the confidentiality of our clients’ data. This tool has
            been developed to run entirely on the “client side.” This means your data is temporarily
            loaded into your browser for screening; it is not uploaded to any server, and thus,
            there is no risk of breaching the confidentiality of your data by using this service.
          </p>
          <p>
            The use of this website is intended as a free service for our clients and laboratories
            to ensure SEDDs delivered to ADS are consistent and comparable. Any commercial use or
            resale of this service by a third party is strictly forbidden, and may be considered a
            violation of copyright law. By clicking Validate, you are agreeing with the above terms.
            Otherwise, <a href="https://www.arcticdataservices.com">click here</a> to return to our
            home page.
          </p>
        </div>
      </Segment>
    </Container>
  )
}
